export default "__VITE_ASSET__8zjpjcjw__"